import { render, staticRenderFns } from "./disc.page.pug?vue&type=template&id=17d39ebb&scoped=true&lang=pug&external"
import script from "./disc.page.ts?vue&type=script&lang=js&external"
export * from "./disc.page.ts?vue&type=script&lang=js&external"
import style0 from "./disc.page.sass?vue&type=style&index=0&id=17d39ebb&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d39ebb",
  null
  
)

export default component.exports